<div class="subscribe-header" (click)="onSubscribeClicked()">
    <div class="outer-content-wrapper">
        <div class="inner-content-wrapper flex">
            {{ txtSubscribe }}
            <sew-icon icon="bell"></sew-icon>
        </div>
    </div>
</div>
